import factory from './factory';

factory('[widget=login]');
